import { scroller } from 'react-scroll';
import config from '@/utils/config';

export default function scrollTo(target: string, props: any = {}) {
  const headerNode = document.querySelector<HTMLElement>(
    config.get('headerContainerSelector')
  );

  const offset = headerNode ? -(headerNode.clientHeight + 15) : 0;

  scroller.scrollTo(target, {
    offset,
    smooth: true,
    ...props,
  });
}
